import {
  TOption,
  TIngredient,
  TFlavor,
  FetchDataIngredientsAction,
  FetchDataIngredientsSuccessAction,
  FetchDataIngredientsErrorAction,
  TRequestMyIngredients,
  GetDataMyIngredientsLocalAction,
  UpdateDataMyIngredientsLocalAction,
  SetDataMyIngredientsRequestLocalAction,
  GetDataMyIngredientsRequestLocalAction,
  UpdateDataMyIngredientsRequestLocalAction,
  FetchDataMyIngredientsAction,
  FetchDataMyIngredientsSuccessAction,
  FetchDataMyIngredientsErrorAction,
  TPrependMyIngredientsAction,
  PrependMyIngredientsAction,
  TRemoveMyIngredientsAction,
  RemoveMyIngredientsAction,
  SortMyIngredientsAction,
  TRequestUpdateMyIngredients,
  UpdateMyIngredientsAction,
  UpdateMyIngredientsSuccessAction,
  UpdateMyIngredientsErrorAction,
  TRequestNewIngradient,
  RequestNewIngradientAction,
  RequestNewIngradientSuccessAction,
  RequestNewIngradientErrorAction,
  RequestNewIngradientResetAction,
  FetchDataFlavorsAction,
  FetchDataFlavorsSuccessAction,
  FetchDataFlavorsErrorAction,
} from './types'

// list all ingredients
export const FETCH_DATA_INGREDIENTS_REQUEST = 'FETCH_DATA_INGREDIENTS_REQUEST';
export const FETCH_DATA_INGREDIENTS_SUCCESS = 'FETCH_DATA_INGREDIENTS_SUCCESS';
export const FETCH_DATA_INGREDIENTS_ERROR = 'FETCH_DATA_INGREDIENTS_ERROR';

// list my ingredients
export const GET_MY_INGREDIENTS_LOCAL = 'GET_MY_INGREDIENTS_LOCAL';
export const UPDATE_MY_INGREDIENTS_LOCAL_BY_LANG = 'UPDATE_MY_INGREDIENTS_LOCAL_BY_LANG';
export const FETCH_DATA_MY_INGREDIENTS_REQUEST = 'FETCH_DATA_MY_INGREDIENTS_REQUEST';
export const FETCH_DATA_MY_INGREDIENTS_SUCCESS = 'FETCH_DATA_MY_INGREDIENTS_SUCCESS';
export const FETCH_DATA_MY_INGREDIENTS_ERROR = 'FETCH_DATA_MY_INGREDIENTS_ERROR';
export const SORT_DATA_MY_INGREDIENTS = 'SORT_DATA_MY_INGREDIENTS';
export const PREPEND_MY_INGREDIENTS = 'PREPEND_MY_INGREDIENTS';
export const REMOVE_MY_INGREDIENTS = 'REMOVE_MY_INGREDIENTS';

export const SET_MY_INGREDIENTS_REQUEST_LOCAL = 'SET_MY_INGREDIENTS_REQUEST_LOCAL';
export const GET_MY_INGREDIENTS_REQUEST_LOCAL = 'GET_MY_INGREDIENTS_REQUEST_LOCAL';
export const UPDATE_MY_INGREDIENTS_REQUEST_LOCAL_BY_LANG = 'UPDATE_MY_INGREDIENTS_REQUEST_LOCAL_BY_LANG';
    
// update list my ingredients
export const UPDATE_MY_INGREDIENTS_REQUEST = 'UPDATE_MY_INGREDIENTS_REQUEST';
export const UPDATE_MY_INGREDIENTS_SUCCESS = 'UPDATE_MY_INGREDIENTS_SUCCESS';
export const UPDATE_MY_INGREDIENTS_ERROR = 'UPDATE_MY_INGREDIENTS_ERROR';

// request ingredient
export const REQUEST_INGREDIENT_REQUEST = 'REQUEST_INGREDIENT_REQUEST';
export const REQUEST_INGREDIENT_SUCCESS = 'REQUEST_INGREDIENT_SUCCESS';
export const REQUEST_INGREDIENT_ERROR = 'REQUEST_INGREDIENT_ERROR';
export const REQUEST_INGREDIENT_RESET = 'REQUEST_INGREDIENT_RESET';

// list all flavors
export const FETCH_DATA_FLAVORS_REQUEST = 'FETCH_DATA_FLAVORS_REQUEST';
export const FETCH_DATA_FLAVORS_SUCCESS = 'FETCH_DATA_FLAVORS_SUCCESS';
export const FETCH_DATA_FLAVORS_ERROR = 'FETCH_DATA_FLAVORS_ERROR';

export const SET_RECIPE_INGREDIENTS = 'SET_RECIPE_INGREDIENTS';
export const RESET_RECIPE_INGREDIENTS = 'RESET_RECIPE_INGREDIENTS';
export const SET_RECIPE_OPTIONS = 'SET_RECIPE_OPTIONS';
export const RESET_RECIPE_OPTIONS = 'RESET_RECIPE_OPTIONS';
export const SET_RECIPE_KEYWORD = 'SET_RECIPE_KEYWORD';
export const RESET_RECIPE_KEYWORD = 'RESET_RECIPE_KEYWORD';
export const RESET_RECIPE = 'RESET_RECIPE';

//list history
export const FETCH_DATA_HISTORY_REQUEST = 'FETCH_DATA_HISTORY_REQUEST';
export const FETCH_DATA_HISTORY_SUCCESS = 'FETCH_DATA_HISTORY_SUCCESS';
export const FETCH_DATA_HISTORY_ERROR = 'FETCH_DATA_HISTORY_ERROR';

// list all ingredients
export const fetchDataIngredients = (): FetchDataIngredientsAction => ({
  type: FETCH_DATA_INGREDIENTS_REQUEST,
});

export const fetchDataIngredientsSuccess = (
  data: TIngredient[]
): FetchDataIngredientsSuccessAction => ({
  type: FETCH_DATA_INGREDIENTS_SUCCESS,
  payload: data,
});

export const fetchDataIngredientsError = (
  error: Error
): FetchDataIngredientsErrorAction => ({
  type: FETCH_DATA_INGREDIENTS_ERROR,
  payload: error,
});

// list my ingredients
export const getDataMyIngredientsLocal = (
  data: TRequestMyIngredients
): GetDataMyIngredientsLocalAction => ({
  type: GET_MY_INGREDIENTS_LOCAL,
  payload: data,
});
export const updateDataMyIngredientsLocal = (
  data: {
    data: TIngredient[],
    lang: string,
    user_id: number,
  }
): UpdateDataMyIngredientsLocalAction => ({
  type: UPDATE_MY_INGREDIENTS_LOCAL_BY_LANG,
  payload: data,
});

export const fetchDataMyIngredients = (): FetchDataMyIngredientsAction => ({
  type: FETCH_DATA_MY_INGREDIENTS_REQUEST,
});

export const fetchDataMyIngredientsSuccess = (
  data: TIngredient[]
): FetchDataMyIngredientsSuccessAction => ({
  type: FETCH_DATA_MY_INGREDIENTS_SUCCESS,
  payload: data,
});

export const fetchDataMyIngredientsError = (
  error: Error
): FetchDataMyIngredientsErrorAction => ({
  type: FETCH_DATA_MY_INGREDIENTS_ERROR,
  payload: error,
});

export const prependMyIngredients = (
  data: TPrependMyIngredientsAction
): PrependMyIngredientsAction => ({
  type: PREPEND_MY_INGREDIENTS,
  payload: data,
});

export const removeMyIngredients = (
  data: TRemoveMyIngredientsAction
): RemoveMyIngredientsAction => ({
  type: REMOVE_MY_INGREDIENTS,
  payload: data,
});

export const sortMyIngredients = (
  data: TOption
): SortMyIngredientsAction => ({
  type: SORT_DATA_MY_INGREDIENTS,
  payload: data,
});

// list my ingredients request
export const setDataMyIngredientsRequestLocal = (
  data: {
    data: TIngredient[],
    lang: string,
    user_id: number,
  }
): SetDataMyIngredientsRequestLocalAction => ({
  type: SET_MY_INGREDIENTS_REQUEST_LOCAL,
  payload: data,
});
export const getDataMyIngredientsRequestLocal = (
  data: TRequestMyIngredients
): GetDataMyIngredientsRequestLocalAction => ({
  type: GET_MY_INGREDIENTS_REQUEST_LOCAL,
  payload: data,
});
export const updateDataMyIngredientsRequestLocal = (
  data: {
    data: TIngredient[],
    lang: string,
    user_id: number,
  }
): UpdateDataMyIngredientsRequestLocalAction => ({
  type: UPDATE_MY_INGREDIENTS_REQUEST_LOCAL_BY_LANG,
  payload: data,
});

// update list my ingredients
export const updateMyIngredients = (
  data: TRequestUpdateMyIngredients
): UpdateMyIngredientsAction => ({
  type: UPDATE_MY_INGREDIENTS_REQUEST,
  payload: data
});

export const updateMyIngredientsSuccess = (
  data: TIngredient[]
): UpdateMyIngredientsSuccessAction => ({
  type: UPDATE_MY_INGREDIENTS_SUCCESS,
  payload: data,
});

export const updateMyIngredientsError = (
  error: Error
): UpdateMyIngredientsErrorAction => ({
  type: UPDATE_MY_INGREDIENTS_ERROR,
  payload: error,
});

// request new ingredient
export const requestNewIngradient = (
  data: TRequestNewIngradient
): RequestNewIngradientAction => ({
  type: REQUEST_INGREDIENT_REQUEST,
  payload: data
});

export const requestNewIngradientSuccess = (
  data: TIngredient
): RequestNewIngradientSuccessAction => ({
  type: REQUEST_INGREDIENT_SUCCESS,
  payload: data,
});

export const requestNewIngradientError = (
  error: any
): RequestNewIngradientErrorAction => ({
  type: REQUEST_INGREDIENT_ERROR,
  payload: error,
});

export const resetRequestNewIngradient = (): RequestNewIngradientResetAction => ({
  type: REQUEST_INGREDIENT_RESET,
});

// list all flavors
export const fetchDataFlavorsRequest = (): FetchDataFlavorsAction => ({
  type: FETCH_DATA_FLAVORS_REQUEST,
});

export const fetchDataFlavorsSuccess = (
  data: TFlavor[]
): FetchDataFlavorsSuccessAction => ({
  type: FETCH_DATA_FLAVORS_SUCCESS,
  payload: data,
});

export const fetchDataFlavorsError = (
  error: Error
): FetchDataFlavorsErrorAction => ({
  type: FETCH_DATA_FLAVORS_ERROR,
  payload: error,
});

// recipe
export const setRecipeIngredients = (ingredients: TIngredient[]) => ({
  type: SET_RECIPE_INGREDIENTS,
  payload: ingredients,
});

export const resetRecipeIngradients = () => ({
  type: RESET_RECIPE_INGREDIENTS,
});

export const setRecipeOptions = (data: {user_id: number, options: string[]}) => ({
  type: SET_RECIPE_OPTIONS,
  payload: data,
});

export const resetRecipeOptions = () => ({
  type: RESET_RECIPE_OPTIONS,
});

export const setRecipeKeyword = (data: string) => ({
  type: SET_RECIPE_KEYWORD,
  payload: data,
});

export const resetRecipeKeyword = () => ({
  type: RESET_RECIPE_KEYWORD,
});

export const resetRecipes = () => ({
  type: RESET_RECIPE,
});

export const fetchListHistoryRequest = (data: any) => ({
    type: FETCH_DATA_HISTORY_REQUEST,
    payload: data,
});

export const fetchListHistorySuccess = (data: any) => ({
    type: FETCH_DATA_HISTORY_SUCCESS,
    payload: data,
});

export const fetchListHistoryError = (error: any) => ({
    type: FETCH_DATA_HISTORY_ERROR,
    payload: error,
});
